var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailwithoutbg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2279 7.19125L10.5505 11.1336L5.76611 7.19125V7.19232L5.77189 7.19765V12.718L10.4966 16.7456L15.2279 12.8735V7.19125Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4554 6.23226L15.2271 7.19121V12.8735L19.0923 9.66853V7.73781C19.0923 7.73781 18.6231 4.9803 16.4554 6.23226Z",
    fill: "#FBBC05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2271 12.8735V20.2436H18.1896C18.1896 20.2436 19.0326 20.1498 19.0932 19.112V9.66852L15.2271 12.8735Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77301 20.2501V12.718L5.76611 12.7127L5.77301 20.2501Z",
    fill: "#C5221F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76573 7.19215L4.54411 6.23852C2.3764 4.98656 1.90625 7.74301 1.90625 7.74301V9.67367L5.76573 12.7125V7.19215Z",
    fill: "#C5221F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76611 7.19247V12.7129L5.77301 12.7182V7.19781L5.76611 7.19247Z",
    fill: "#C5221F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90625 9.67511V14.3969V19.1186C1.96598 20.1575 2.80995 20.2502 2.80995 20.2502H5.77248L5.76573 12.7129L1.90625 9.67511Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailwithoutbg);
export default __webpack_public_path__ + "static/media/gmailwithoutbg.aa70d8b1fcd31650b70bb0127e3635a8.svg";
export { ForwardRef as ReactComponent };